import Model, { belongsTo, attr } from '@ember-data/model';
import { apiAction } from '@mainmatter/ember-api-actions';
import { service } from '@ember/service';

export default class Agreement extends Model {
  @service store;

  @belongsTo('agreement-page', { async: false, inverse: 'agreements' }) agreementPage;
  @belongsTo('invite', { async: true, inverse: 'agreements' }) invite;
  @belongsTo('nda-signature', { async: true, inverse: 'agreement' }) signature;
  @belongsTo('visitor-nda-signature', { async: true, inverse: 'agreement' }) visitorSignature;

  @attr('string') body;
  @attr('string') documentUrl;
  @attr('string') footer;
  @attr('string') videoUrl;
  @attr('string') name;
  @attr('boolean') optional;
  @attr('boolean') enabled;
  @attr('number') position;

  async fillAgreement() {
    const response = await apiAction(this, {
      data: {},
      method: 'GET',
      path: 'filled-agreement',
      requestType: 'filledAgreement',
    });
    this.store.pushPayload(response);
  }
}
